export default "__VITE_ASSET__e1d2d8c9__"